/**
 * 파일명 : usr0103p.jsx
 * 설명 : 사용자정보등록
 * 수정내역
 ************************************************
 * Version    수정일자      수정자    수정내용      
 ************************************************
 *     
 */

/************************************************
 * Import 영역  
 ************************************************/
/************************************************
 * Import 영역
 ************************************************/
/* React */
import React from 'react';
import validator from 'validator';
import locale from 'antd/lib/locale/ko_KR';
import dayjs from 'dayjs';

/* Reducer */
import { useAppSelector, useAppDispatch } from '../../../redux/hooks';
import { Usr0103p1Action } from '../../../redux/slice/usr/usr0103p1_slice';
import { IUserStCdState, IDeptCdState } from '../../../redux/models/usr/usr0103m_model';


/* AntD */
import { Input, Layout, Row, Col, Space, Button, Descriptions, DatePicker, ConfigProvider, Select } from 'antd';
import DaumPost from 'pages/components/DaumPost';

/* 업무 */
import * as commonProxy from 'libs/CommonProxy';
import * as common from 'libs/common';

/************************************************
 * 전역변수 선언영억
 ************************************************/
const Usr0103p1 = (props:any) => {
    const { Search }  = Input;
    /************************************************
     * 화면 초기화 영역  
     ************************************************/
    /**
     * 기능 : State / Reducer 선언
     * param : 
     */
    const dispatch = useAppDispatch();
    const mmbrItems    = useAppSelector((state) => state.Usr0103p1.mmbrItems);
    const deptCdList   = useAppSelector((state) => state.Usr0103p1.deptCdList);
    const dutyCdList   = useAppSelector((state) => state.Usr0103p1.dutyCdList);
    const postCdList   = useAppSelector((state) => state.Usr0103p1.postCdList);
    const userStCdList = useAppSelector((state) => state.Usr0103p1.userStCdList);
    const [addrType, setAddrType] = React.useState('');

    /**
     * 기능 : componentDidMount
     * 설명 : 화면 최초 로드시에 필요한 기능을 구현한다.
     * param : 
     * return : None
     */
     React.useEffect(() => {
        fn_DeptCds();
        setUserStCdList();
        setDutyCdList();
        setPostCdList();

        return () => {
            dispatch(Usr0103p1Action.initState());
        }
    }, []);


    React.useEffect(() => {
        if (!props || common.isEmptyString(props.empNo)) {
            if (userStCdList && userStCdList.length > 0) {
                dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, userStCd : 'A' }));
            }
        }

        if (deptCdList && deptCdList.length > 0 && dutyCdList && dutyCdList.length > 0 && postCdList && postCdList.length > 0 && userStCdList && userStCdList.length > 0) {
            if (props && !common.isEmptyString(props.empNo)) {
                /* 변수선언 및 셋팅 영역 */
                // 입력파라미터
                const requestData = {
                    empNo: props.empNo
                };

                /* 트렌젝션 호출 및 결과 셋팅 */
                commonProxy.callAsyncSvc(requestData, {
                    txCd: 'TRUSRR0003',
                    success: (responseData:any) => {
                        dispatch(Usr0103p1Action.setMmbrItems(responseData.userList[0]));
                    },
                });
            }
        }
    }, [deptCdList, dutyCdList, postCdList, userStCdList]);


    /**
     * 기능 : fn_DeptCds
     * 설명 : 부서코드 콤보박스 데이터 조회
     * param : 
     * return : None
     **/
     const fn_DeptCds = () => {
        /* 변수선언 및 셋팅 영역 */
        // 입력파라미터
        const requestData = {
            deptStCd: 'A'
        };

        /* 트렌젝션 호출 및 결과 셋팅 */
        commonProxy.callAsyncSvc(requestData, {
            txCd: 'TRCOMR0005',
            success: (responseData:any) => {
                dispatch(Usr0103p1Action.setDeptCdList(responseData.deptItems));
            },
        });
    };

    const deptOptions = React.useCallback(() => {
        let arrOptions: IDeptCdState[] = [];
        deptCdList.forEach((item:IDeptCdState) => {
            arrOptions.push({
                label: item.deptNm,
                value: item.deptCd
            });
        });

        return arrOptions;
    }, [deptCdList]);


    const setDutyCdList = () => {
        const option = {
            useYn: 'Y',
            callback: (datas:IUserStCdState[]) => {
                let arrOptions:IUserStCdState[] = [];
                datas.forEach((item:IUserStCdState) => {
                    arrOptions.push({
                        label: item.cdNm,
                        value: item.cd
                    });
                });

                dispatch(Usr0103p1Action.setDutyCdList(arrOptions));
            }
        };
        common.getComCodeList('012', option);
    }


    const setPostCdList = () => {
        const option = {
            useYn: 'Y',
            callback: (datas:IUserStCdState[]) => {
                let arrOptions:IUserStCdState[] = [];
                datas.forEach((item:IUserStCdState) => {
                    arrOptions.push({
                        label: item.cdNm,
                        value: item.cd
                    });
                });

                dispatch(Usr0103p1Action.setPostCdList(arrOptions));
            }
        };
        common.getComCodeList('011', option);
    }

    // 우편번호 찾기 번튼 클릭(팝업Open)
    const addrSearch = () => {
        setAddrType('USER');
    }

    const dlvAddrSearch = () => {
        setAddrType('DLV');
    }

    // 우편번호 선택 완료
    const handleComplete = (data:any) => {
        // 주소 셋팅
        dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, userPostNo : data.zonecode, userAddr : data.address }));
        setAddrType('');
    }
    const handleDlvAddrComplete = (data:any) => {
        // 주소 셋팅
        dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, userDlvPostNo : data.zonecode, userDlvAddr : data.address }));
        setAddrType('');
    }
    

    const setUserStCdList = () => {
        const option = {
            useYn: 'Y',
            callback: (datas:IUserStCdState[]) => {
                let arrOptions:IUserStCdState[] = [];
                datas.forEach((item:IUserStCdState) => {
                    arrOptions.push({
                        label: item.cdNm,
                        value: item.cd
                    });
                });

                dispatch(Usr0103p1Action.setUserStCdList(arrOptions));
            }
        };
        common.getComCodeList('003', option);
    }


    /************************************************
     * Render 변수 선언 및 셋팅영역
     ************************************************/
    /* AntD */
    const { Content } = Layout;

    /************************************************
     * 이벤트 함수 영역
     ************************************************/
	/**
     * 기능 : 저장버튼 클릭 이벤트
     * 설명 : 등록/수정
     * param : 
     * return : None
     */

    const btnSave_onClick = () => {
        /* 정합성 체크 */
        if (!fn_CheckValidation('save')) {
            return;
        }

        /* 변수선언 및 셋팅 영역 */
        // 입력파라미터
        const requestData = { ...mmbrItems };

        /* 트렌젝션 호출 및 결과 셋팅 */
        commonProxy.callAsyncSvc(requestData, {
            txCd: 'TRUSRS0005',
            success: (responseData:any) => {
                dispatch(Usr0103p1Action.setMmbrItems(responseData.userItems));

                const param = {
                    title : '위드정보 확인',
                    contents: '정상적으로 처리되었습니다.',
                };

                common.openAlert(param);
            },
        });
    };

    /**
     *  기능 : DatePicker 데이터 변경
     *  설명 : DatePicker 데이터 변경값을 받는다
     *  param :
     *  return : None
     */
    const calendar_onChange = (_:any, dateStrings:any) => {
        dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, joinDt : dateStrings }));
    }

	/**
     * 기능 : 초기화
     * 설명 : 입력컴포넌트
     * param : 
     * return : None
     */
    const btnReset_onClick = React.useCallback(() => {
        dispatch(Usr0103p1Action.initState());
    }, []);

    /**
     * 기능 : onClick 이벤트 선언
     * param : 
     */
    const onClick = async (e:any) => {
        const buttonName = e.currentTarget.name;
        switch (buttonName) {
            case 'btnReset': {
                btnReset_onClick();
                break;
            }
            case 'btnSave': {
                btnSave_onClick();
                break;
            }
            case 'btnClose': {
                props.cancel();
                break;
            }
            default:
        }
    };

    /************************************************
     * 개발자함수 영역
     ************************************************/
	/**
     * 기능 : 정합성체크
     * 설명 : 정합성체크
     * param : 
     * return : None
     */
     const fn_CheckValidation = (tran_div:string) => {
        let params = [];
        let result = true;

        if(mmbrItems.userId !== 'admin'){
            if (tran_div === 'save') {
                let result = true;
                if(!common.isEmptyString(mmbrItems.newPswd) || !common.isEmptyString(mmbrItems.chkPswd)){
                    if(mmbrItems.newPswd !== mmbrItems.chkPswd){
                        const param = {
                            title : '위드정보 확인',
                            contents: '비밀번호 확인이 일치하지 않습니다.',
                        };
                        common.openInfo(param);
                        return false;
                    }
                }

                if(common.isEmptyString(mmbrItems.userId)) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '사용자ID는 필수입력 항목입니다.',
                    };
                    common.openInfo(param);
                    return false;
                }

                if(common.isEmptyString(mmbrItems.userNm)) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '사용자명은 필수입력 항목입니다.',
                    };
                    common.openInfo(param);
                    return false;
                }

                if(common.isEmptyString(mmbrItems.joinDt)) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '입사일자는 필수입력 항목입니다.',
                    };
                    common.openInfo(param);
                    return false;
                }

                if(common.isEmptyString(mmbrItems.deptCd)) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '부서는 필수입력 항목입니다.',
                    };
                    common.openInfo(param);
                    return false;
                }

                if(common.isEmptyString(mmbrItems.dutyCd)) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '직책은 필수입력 항목입니다.',
                    };
                    common.openInfo(param);
                    return false;
                }

                if(common.isEmptyString(mmbrItems.postCd)) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '직위는 필수입력 항목입니다.',
                    };
                    common.openInfo(param);
                    return false;
                }

                if (common.isEmptyString(mmbrItems.userEmail)) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '이메일은 필수입력 항목입니다.',
                    };
                    common.openInfo(param);
                    return false;
                }

                const checkHan = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
                if (mmbrItems.userEmail && (!validator.isEmail(mmbrItems.userEmail) || checkHan.test(mmbrItems.userEmail))) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '이메일 형식을 확인하세요.',
                    };
                    common.openInfo(param);
                    return false;
                }

                const mobileNo1 = mmbrItems.mobileNo ? mmbrItems.mobileNo : '';
                const mobileNo2 = mmbrItems.mobileNo ? mmbrItems.mobileNo.replace(/-/gi, '') : '';
                if (!mmbrItems.mobileNo) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '휴대전화는 필수입력 항목입니다.',
                    };
                    common.openInfo(param);
                    return false;
                }

                if (mobileNo1.indexOf('-') !== -1 && mobileNo1.split('-').length !== 3) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '휴대전화 형식을 확인하세요.',
                    };
                    common.openInfo(param);
                    return false;
                }

                if (mobileNo2.length !== 10 && mobileNo2.length !== 11) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '휴대전화 형식을 확인하세요.',
                    };
                    common.openInfo(param);
                    return false;
                }

                return result
            }
        }

        return result;
    }

    return (
        /* 화면 디자인 영역*/
        <Layout>
            <Content>
                <Descriptions bordered column={1} size='small'>
                    <Descriptions.Item label='사용자ID' labelStyle={{width:'30%', fontSize:'8pt'}}>
                        <Input id='inputUserId' name='userId' autoComplete='new-password' size='small' value={mmbrItems.userId} onChange={e => { dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, userId : e.currentTarget.value })) }} disabled={!common.isEmptyString(mmbrItems.empNo)}/>
                    </Descriptions.Item>
                    <Descriptions.Item label='이름' labelStyle={{width:'30%', fontSize:'8pt'}}>
                        <Input id='inputUserNm' name='userNm' autoComplete='new-password' size='small' value={mmbrItems.userNm} onChange={e => { dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, userNm : e.currentTarget.value })) }}/>
                    </Descriptions.Item>
                    <Descriptions.Item label='상태' labelStyle={{fontSize:'8pt'}}>
                        <Select 
                            size='small'
                            showSearch
                            style={{
                                width: 80,
                            }}
                            optionFilterProp='label'
                            defaultValue=''
                            options={userStCdList}
                            value={mmbrItems.userStCd}
                            onChange={val => dispatch(Usr0103p1Action.setMmbrItems({...mmbrItems, userStCd: val}))}
                            // ReadOnly 적용
                            {...common.getReadonlySelectboxProps(!common.isAdmin() || common.isEmptyString(mmbrItems.empNo))}
                        ></Select>
                    </Descriptions.Item>
                    <Descriptions.Item label='입사일자' labelStyle={{fontSize:'8pt'}}>
                        <ConfigProvider locale={locale}>
                            <DatePicker
                                size='small'
                                inputReadOnly
                                disabled={!common.isAdmin()}
                                allowClear={false}
                                value={dayjs(mmbrItems.joinDt)}
                                onChange={calendar_onChange}/> 
                        </ConfigProvider>
                    </Descriptions.Item>
                    <Descriptions.Item label='직위' labelStyle={{fontSize:'8pt'}}>
                        <Select 
                            size='small'
                            showSearch
                            style={{
                                width: 100,
                            }}
                            optionFilterProp='label'
                            defaultValue=''
                            options={postCdList}
                            value={mmbrItems.postCd}
                            onChange={val => dispatch(Usr0103p1Action.setMmbrItems({...mmbrItems, postCd: val}))}
                            // ReadOnly 적용
                            {...common.getReadonlySelectboxProps(!common.isAdmin())}
                        ></Select>
                    </Descriptions.Item>
                    <Descriptions.Item label='직책' labelStyle={{fontSize:'8pt'}}>
                        <Select 
                            size='small'
                            showSearch
                            style={{
                                width: 100,
                            }}
                            optionFilterProp='label'
                            defaultValue=''
                            options={dutyCdList}
                            value={mmbrItems.dutyCd}
                            onChange={val => dispatch(Usr0103p1Action.setMmbrItems({...mmbrItems, dutyCd: val}))}
                            // ReadOnly 적용
                            {...common.getReadonlySelectboxProps(!common.isAdmin())}
                        ></Select>
                    </Descriptions.Item>

                    <Descriptions.Item label='부서' labelStyle={{fontSize:'8pt'}}>
                        <Select 
                            size='small'
                            showSearch
                            style={{
                                width: 150,
                            }}
                            optionFilterProp='label'
                            defaultValue=''
                            options={deptOptions()}
                            value={mmbrItems.deptCd}
                            onChange={val => dispatch(Usr0103p1Action.setMmbrItems({...mmbrItems, deptCd : val}))}
                            // ReadOnly 적용
                            {...common.getReadonlySelectboxProps(!common.isAdmin())}
                        ></Select>
                    </Descriptions.Item>
                    <Descriptions.Item label='휴대전화' labelStyle={{fontSize:'8pt'}}>
                        <Input id='inputMobileNo' name='mobileNo' autoComplete='new-password' size='small' value={mmbrItems.mobileNo} onChange={e => { dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, mobileNo : e.currentTarget.value })) }}/>
                    </Descriptions.Item>

                    <Descriptions.Item label='이메일' span={1} labelStyle={{fontSize:'8pt'}}>
                        <Input id='inputUserEmail' name='userEmail' autoComplete='new-password' size='small' value={mmbrItems.userEmail} onChange={e => { dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, userEmail : e.currentTarget.value })) }}/>
                    </Descriptions.Item>

                    <Descriptions.Item label='주소' span={1}>
                        <Row gutter={[0, 8]}>
                            <Col span={24}>
                                <Search size='small' id='userPostNo' autoComplete='new-password' style={{width : '100%'}} placeholder='우편번호' readOnly onSearch={addrSearch} value={mmbrItems.userPostNo} enterButton title='우편번호'/>
                                {addrType === 'USER' && (
                                    <DaumPost onComplete={handleComplete} />
                                )}
                            </Col>
                            <Col span={24}>
                                <Input size='small' autoComplete='new-password' placeholder='주소' readOnly value={mmbrItems.userAddr} style={{width:'100%'}}/>
                            </Col>
                            <Col span={24}>
                                <Input size='small' name='userDtlAddr' autoComplete='new-password' placeholder='상세주소' value={mmbrItems.userDtlAddr} maxLength={500} title='상세주소' style={{width:'100%'}} onChange={e => { dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, userDtlAddr : e.currentTarget.value })) }}/>
                            </Col>
                        </Row>
                    </Descriptions.Item>

                    <Descriptions.Item label='배송지주소' span={1}>
                        <Row gutter={[0, 8]}>
                            <Col span={24}>
                                <Search size='small' id='userDlvPostNo' autoComplete='new-password' style={{width : '100%'}} placeholder='우편번호' readOnly onSearch={dlvAddrSearch} value={mmbrItems.userDlvPostNo} enterButton title='우편번호'/>
                                {addrType === 'DLV' && (
                                    <DaumPost onComplete={handleDlvAddrComplete} />
                                )}
                            </Col>
                            <Col span={24}>
                                <Input size='small' autoComplete='new-password' placeholder='배송지주소' readOnly value={mmbrItems.userDlvAddr} style={{width:'100%'}}/>
                            </Col>
                            <Col span={24}>
                                <Input size='small' name='userDlvDtlAddr' autoComplete='new-password' placeholder='배송지 상세주소' value={mmbrItems.userDlvDtlAddr} maxLength={500} title='배송지 상세주소' style={{width:'100%'}} onChange={e => { dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, userDlvDtlAddr : e.currentTarget.value })) }}/>
                            </Col>
                        </Row>
                    </Descriptions.Item>

                    <Descriptions.Item label='현비밀번호' labelStyle={{fontSize:'8pt'}}>
                        <Input.Password id='inputOldPswd' autoComplete='one-time-code' placeholder='input password' name='oldPswd' size='small' value={mmbrItems.oldPswd} onChange={e => { dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, oldPswd : e.currentTarget.value })) }}/>
                    </Descriptions.Item>
                    <Descriptions.Item label='새비밀번호' labelStyle={{fontSize:'8pt'}}>
                        <Input.Password id='inputNewPswd' autoComplete='one-time-code' placeholder='input password' name='newPswd' size='small' value={mmbrItems.newPswd} onChange={e => { dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, newPswd : e.currentTarget.value })) }}/>
                        <Input.Password id='inputChkPswd' autoComplete='one-time-code' placeholder='input password' name='chkPwd'  size='small' value={mmbrItems.chkPswd}  onChange={e => { dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, chkPswd : e.currentTarget.value })) }}/>
                    </Descriptions.Item>
                </Descriptions>

                <Row justify='center' style={{ marginTop: 20 }}>
                    <Col>
                        <Space direction='horizontal' size='small'>
                            {common.isAdmin() ?
                            <Button
                                size='small'
                                name='btnReset'
                                className='background-color-default-button'
                                onClick={onClick}
                                >
                                초기화
                            </Button> : null}
                            {common.isAdmin() || mmbrItems.empNo === common.getEmpNo() ?
                            <Button
                            size='small'
                                name='btnSave'
                                className='background-color-primary-button'
                                onClick={onClick}
                            >
                                저장
                            </Button> : null}
                            <Button
                                size='small'
                                name='btnClose'
                                className='background-color-default-button'
                                onClick={onClick}
                            >
                                닫기
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Content>
        </Layout>
    );
}

export default Usr0103p1;